import type { TestStateSection, TestState } from '@merels/web/deps/debug/positions/positions'
import { StateSection } from './StateSection'

export interface StateListViewProps {
  sections: TestStateSection[]
  expandedSections: Set<string>
  searchText: string
  selectedStateName: string | null
  showJsonViewer: boolean
  onToggleSection: (title: string) => void
  onStateClick: (state: TestState) => void
}

export function StateListView({
  sections,
  expandedSections,
  searchText,
  selectedStateName,
  showJsonViewer,
  onToggleSection,
  onStateClick
}: StateListViewProps) {
  if (sections.length === 0) {
    return (
      <div className="p-4 text-sm text-muted text-center">
        No states match your search
      </div>
    )
  }

  return (
    <div>
      {sections.map(section => {
        const isExpanded = expandedSections.has(section.title) || searchText.trim() !== ''
        return (
          <StateSection
            key={section.title}
            section={section}
            isExpanded={isExpanded}
            selectedStateName={selectedStateName}
            showJsonViewer={showJsonViewer}
            onToggle={() => onToggleSection(section.title)}
            onStateClick={onStateClick}
          />
        )
      })}
    </div>
  )
}

